import React from 'react';
import style from './index.less';
import PropTypes from 'prop-types';
import { Layout, Icon, Popover, Badge } from 'antd';
import { connect } from 'react-redux';
import { logout } from 'actions/oldAccount.js';
import {toUrl} from 'utils/tool.js';
import { STATUS } from 'utils/const';
import { Link } from 'react-router-dom';
import Ficon from 'components/Ficon';
import {getUrl} from 'utils/tool.js';
import { withRouter } from 'react-router-dom';
import Jump from 'components/Jump';
import envcompany from 'envcompany';
const { Header } = Layout;

const TopMenu = (props) => {
    let item;
    const content = <Badge dot={props.badge} offset={[8,-8]}>
        <a {...props} className={style['base-nav-name']}>
            <Ficon type={props.icon} />
            <span style={{ paddingLeft: 5 }}>{props.name}</span>
            {props.content}
        </a>
    </Badge>;
    if(props.popContent){
        item = <Popover placement="bottomRight"
            onVisibleChange={props.popoverChange}
            getPopupContainer={() => document.getElementById('main-header')}
            content={props.popContent} title="" trigger="click"
            style={{background: '#FFFFFF'}}>{content}</Popover>;
    }else{
        item = content;
    }
    return (
        <div style={{display:'inline-block',position:'relative'}}>
            {item}
        </div>
    );
};

export class NewHeader extends React.Component {


    constructor(props){
        super(props);
        this.state = {
            first:props.account?props.account.is_show_tips:false,
            userArrow:'down'
        };
    }
    logout = () => {
        logout().then(e=>{
            toUrl('/login');
        }).catch(()=>{
            toUrl('/login');
        });
    }
    open(url){
        toUrl(url);
    }

    jump(url){
        this.props.history.push(url);
    }

    onStatusClick=()=>{
        if( this.props.account && this.props.account.status === STATUS.UNCERTIFIED){
            this.props.history.push('/pages/auth');
        }
    }

    onCloseFirst = ()=>{
        this.setState({first:false});
    }
    checkShowStatus = ()=>{
        const account = this.props.account || {};
        return !this.props.isAdmin && (account.status === STATUS.PASS || account.status === STATUS.TOCERTIFIED);
    }

    popoverChange=(visible)=>{
        if(!visible){
            this.setState({userArrow:'down'});
        }else{
            this.setState({userArrow:'up'});
        }
    }


    render() {
        const account = this.props.account || {};

        const content = <div className={style['use-menu']}>
            {this.props.isAdmin?null:<Link to="/pages/password/update"><span>Change password</span></Link>}
            <a onClick={this.logout}><span>Log out</span></a>
        </div>;

        const userContent = <Icon type={this.state.userArrow} style={{fontSize:16,transform:'scale(0.7,0.7)',color:'#FFFFFF', padding: '0 1px 0 5px'}} />;
        const HeaderStyle = {display:'flex',  background: '#404265', padding: 0, position: 'fixed', zIndex: 9, left: 0, right: 0,...this.props.style};
        let userName,statuText;

        if(account.account_id){
            userName = [<TopMenu popoverChange={this.popoverChange} popContent={content} style={{paddingRight:'10px'}} from="ficon" name={account.display_name} content={userContent}/>];

            // <Popover getPopupContainer={() => document.getElementById('main-header')} content={content} title="" trigger="click">
            //     <TopMenu style={{paddingRight:'10px'}} from="ficon" icon="user" name={account.email} content={userContent}/>
            // </Popover>];
            if(!this.props.isAdmin){
                if(!this.props.isAdmin && (account.status === STATUS.PASS || account.status === STATUS.TOCERTIFIED)){
                    userName.push(statuText);
                }
            }
        }else{
            userName = <TopMenu href={getUrl('/login')} icon="user" name="Login" />;
        }

        let userTab = <div>{userName}</div>;

        if(!this.props.noUserTab && !this.props.isAdmin){
            userTab = <div>
                {/* <TopMenu target="_blank" href={getDocUrl('/docs/appface.html')} icon="file-text" name="文档中心" /> */}
                {userName}
            </div>;
        }


        return (
            <Header style={HeaderStyle}>
                <div className={style.logo} >
                    <Jump href="/pages">
                        {envcompany.logoImg}
                    </Jump>
                </div>
                <div id="main-header" className={style['main-header']}>
                    {userTab}
                </div>
            </Header>
        );
    }
}
NewHeader.contextTypes = {
    router: PropTypes.object
};
function select(state) {
    return {
        account: state.account.info,
        title:state.pageData.title,
    };
}

export default connect(select)(withRouter(NewHeader));



// WEBPACK FOOTER //
// ./src/components/Header/index.js